import { useLang } from '@/i18n';
import styles from './index.module.scss';
import { termsMap } from '../../../../config/footerText';
import { useRouter } from 'next/router';
import EfFooterTc from '@elem/ui/ef-footer-tc';
export default function Comp() {
    const { t } = useLang('theProduct.FooterTcA');
    const { locale = 'jp' } = useRouter();
    return (
        <>
            <EfFooterTc list={termsMap[locale]} className={styles.comp} />
        </>
    );
}
